require("./data-list-with-segment.scss");